import { useSocket } from '@gogame/sockets';
import { EVENT_HANDSHAKE } from './constants';

export const useSocketHandShake = () => {
  const socket = useSocket();
  return (handshakeToken) => {
    socket.emit(EVENT_HANDSHAKE, { handshakeToken });
  };
};
